import { faHeart as faHeartEmpty } from '@fortawesome/pro-light-svg-icons/faHeart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DragAndDrop, Loader, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';
import { noop } from '../../../lib/utils';
import getDraggableItemSchema from '../../../lib/utils/getDraggableItemSchema';
import FuelTypePropType from '../../prop-types/fuelType';
import StationPropType from '../../prop-types/station';
import GenericStationListItem from '../GenericStationListItem/index';
import styles from './FavoriteStations.module.css';

const cx = classnames.bind(styles);

export default function FavoriteStations({
  fuelType,
  isEditable,
  loading,
  onPricesPosted,
  onReorder,
  stations,
}) {
  const { t } = useTranslation('favorites');

  if (loading) {
    return (
      <Loader size="lg">
        {t('loadingFavoriteStations')}
      </Loader>
    );
  }

  if (stations.length === 0) {
    return (
      <Text color="midnight" className={cx('noStationsMessage')}>
        <Trans i18nKey="noStationsMessage" ns="favorites">
          You have no stations favorited in this list.
          <br />
          <br />
          Click the <FontAwesomeIcon icon={faHeartEmpty} size="2x" className={cx('heartSymbol')} /> symbol when viewing a station to add it to your favorites.
        </Trans>
      </Text>
    );
  }

  const stationItems = [];
  if (stations.length) {
    stations.forEach((station) => {
      const favoriteStation = (
        <GenericStationListItem
          key={station.id}
          fuelType={fuelType}
          hideDeals={isEditable}
          onPricesPosted={onPricesPosted}
          shouldVisitStation={!isEditable}
          showFavoriting={isEditable}
          showQuickReport={!isEditable}
          station={station}
        />
      );

      if (isEditable) {
        stationItems.push(getDraggableItemSchema(station.id, favoriteStation));
      } else {
        stationItems.push(favoriteStation);
      }
    });
  }

  return (
    <>
      {isEditable ? (
        <DragAndDrop
          groupName="favoriteStations"
          items={stationItems}
          onFinishedDragging={onReorder}
        />
      ) : stationItems}
    </>
  );
}

FavoriteStations.propTypes = {
  fuelType: FuelTypePropType,
  isEditable: PropTypes.bool,
  loading: PropTypes.bool,
  onPricesPosted: PropTypes.func,
  onReorder: PropTypes.func,
  stations: PropTypes.arrayOf(StationPropType),
};

FavoriteStations.defaultProps = {
  fuelType: undefined,
  isEditable: false,
  loading: false,
  onPricesPosted: noop,
  onReorder: noop,
  stations: [],
};
